import { render, staticRenderFns } from "./UserPermissionsReport.vue?vue&type=template&id=1f9c7322&scoped=true&"
import script from "./UserPermissionsReport.vue?vue&type=script&lang=js&"
export * from "./UserPermissionsReport.vue?vue&type=script&lang=js&"
import style0 from "./UserPermissionsReport.vue?vue&type=style&index=0&id=1f9c7322&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f9c7322",
  null
  
)

export default component.exports